// Decorative Tamil letters and learning icons for `.tabs-bg` sections.
// Purely visual: aria-hidden, no pointer events, and the letters are drawn
// by CSS (`content: attr(data-glyph)`) so they are not page text - screen
// readers, search engines and copy/paste ignore them. Styles: .tamil-decor in
// Style.css. Place as the first child of a `.tabs-bg` section.

// top/left/right are percentages of the section; size in rem; `wide` items
// only show from the md breakpoint up, to keep phones uncluttered.
const ITEMS = [
  { glyph: "அ", top: 8, left: 3, size: 4.5, rotate: -12, tone: "red" },
  { glyph: "ழ", top: 62, left: 6, size: 3.5, rotate: 8, tone: "blue", wide: true },
  { icon: "bi-book", top: 34, left: 1.5, size: 2.2, rotate: -8, tone: "blue", wide: true },
  { glyph: "க", top: 84, left: 20, size: 2.6, rotate: 14, tone: "red", wide: true },
  { icon: "bi-pencil", top: 12, left: 26, size: 1.6, rotate: 20, tone: "red", wide: true },
  { word: "தமிழ்", top: 4, right: 20, size: 2.4, rotate: -4, tone: "blue", wide: true },
  { glyph: "ஆ", top: 14, right: 3, size: 4, rotate: 10, tone: "blue" },
  { icon: "bi-music-note-beamed", top: 44, right: 2, size: 2, rotate: 12, tone: "red", wide: true },
  { glyph: "இ", top: 70, right: 5, size: 3.4, rotate: -10, tone: "red" },
  { icon: "bi-chat-quote", top: 88, right: 24, size: 1.8, rotate: -6, tone: "blue", wide: true },
  { glyph: "ஃ", top: 52, left: 44, size: 2, rotate: 0, tone: "blue", wide: true },
  { icon: "bi-mortarboard", top: 80, left: 58, size: 2, rotate: 8, tone: "red", wide: true },
];

const TamilDecor = () => (
  <div className="tamil-decor" aria-hidden="true">
    {ITEMS.map((item, index) => {
      const style = {
        top: `${item.top}%`,
        ...(item.left !== undefined ? { left: `${item.left}%` } : { right: `${item.right}%` }),
        fontSize: `${item.size}rem`,
        "--decor-rotate": `${item.rotate}deg`,
        animationDelay: `${(index % 6) * -2.5}s`,
      };
      const className = `tamil-decor-item tamil-decor-${item.tone} ${item.wide ? "d-none d-md-block" : ""}`;
      return item.icon ? (
        <i key={index} className={`bi ${item.icon} ${className}`} style={style}></i>
      ) : (
        <span key={index} className={`${className} tamil-font`} data-glyph={item.glyph || item.word} style={style}></span>
      );
    })}
  </div>
);

export default TamilDecor;
